import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import CsvDownloadButton from 'react-json-to-csv';
import { Slide, toast } from 'react-toastify';
import {FileDownloadIcon,Edit,Save,Delete,Print,Download } from '@mui/icons-material';
import { Row, Col } from "react-bootstrap";
import { useNavigate, Link, useParams , useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';

const CustomTable = ({ globalSearch=false }) => {
  const navigate = useNavigate();    
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [mockData2, setMockData2] = useState(0);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    imageurl: 'contains',
    matnum: 'contains',
    matname: 'contains',
    contractprice: 'equals',
    sellingprice: 'equals'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const mockData = useRef([]);

  const downloadFile = (count) => {
    const user = AuthVerify.getUser();
    const ctrnum=searchParams.get("ctrnum");
    let url = `/corporate/contract/${user.arnum}/${ctrnum}?limit=${count}&offset=0`;
    // let url = `/corporate/contract/${user.arnum}/${ctrnum}`;
    Axios.get(url)
    .then(response=>{
      if(response.data?.data?.items?.items){
        mockData.current=response.data?.data?.items?.items??[];
        setMockData2(response.data?.data?.items?.items??[])
      }
    })
  };

  const handleDeleteRow = useCallback(
    (row) => {
      // if (
      //   !window.confirm(`Are you sure you want to delete ${row.getValue('firstName')}`)
      // ) {
      //   return;
      // }
      //send api delete request here, then refetch or update local table data for re-render
      data.splice(row.index, 1);
      setData([...data]);
    },
    [data],
  );

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
          filterQuery+=`&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }
    
    const user = AuthVerify.getUser();
    const ctrnum=searchParams.get("ctrnum");
    let url = `/corporate/contract/${user.arnum}/${ctrnum}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.items.items??[]);
          setRowCount(response.data?.data.items.count);
          if(mockData.current.length==0)downloadFile(response.data?.data.items.count)
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.imageurl,
        id: 'imageurl',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnFilterModes: false,
        header: 'Product',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          <a href="#">
            <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(cell.getValue())} alt="Product" />
          </a>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'matnum',
        header:  "Product Code",
        Cell: ({ cell, row }) => (
          <>
            <p className="product-name">
                <Link to={"/product-detail?matnum="+cell.getValue()}>{cell.getValue()}</Link>
            </p>
          </>         
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'matname',
        header:  "Description",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'contractprice',
        header:  "Contract price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      },
      {
        accessorKey: 'sellingprice',
        header: "Selling Price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      }
      //end
    ],
    [],
  );

  return (
    <>
    <Col sm={12} style={{ padding: "5px 0px 10px 0px" }}>
          <CsvDownloadButton delimiter={","} data={mockData2} style={{float:"right", textDecoration:"none", fontWeight:"bold", background:"none", color:"#1890ff"}} filename="ContractDetails.csv">Download as CSV</CsvDownloadButton>
      </Col>
      <Row>
      </Row>
        <MaterialReactTable
          columns={columns}
          data={data}
          // enableStickyHeader
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{ 
            showColumnFilters: true
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef} 
          rowCount={rowCount}
          enableEditing
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Print">
                <IconButton onClick={() => table.setEditingRow(row)}>
                  <Print />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Export">
                <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                  <Download />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps= {({ cell, column, row, table }) =>({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
        {/* <div className="cart_navigation">
          <button className="button btn-proceed-checkout" title="Proceed to Save the Changes" type="button" onClick={() => saveChangesHandler()}><span>Save Changes</span></button>
        </div> */}
    </>
  );
};

export default CustomTable;
